/**
 * location.pathname wrapper
 * @return {string} location.pathname
 */
const pathname = () => window.location.pathname;

/**
 * location.origin wrapper
 * @return {string} location.origin
 */
const origin = () => window.location.origin;

/**
 * location.href wrapper
 * @return {string} location.href
 */
const href = () => window.location.href;

/**
 * location.origin + location.pathname
 * @return {string} location.origin + location.pathname
 */
const path = () => `${origin()}${pathname()}`;

export default {
  path,
  origin,
  pathname,
  href,
};



// WEBPACK FOOTER //
// ./src/phase2/survey/app/locations.js